import { render, staticRenderFns } from "./StoreStatistics.vue?vue&type=template&id=890afad2&"
import script from "./StoreStatistics.vue?vue&type=script&lang=js&"
export * from "./StoreStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports